import {
  SearchContentProvider,
  SearchProviderContext,
  SearchProviderRegistry,
  SearchResultItem,
} from './types';

class DefaultSearchProviderRegistry implements SearchProviderRegistry {
  private providers: Map<string, SearchContentProvider> = new Map();

  register(provider: SearchContentProvider): void {
    this.providers.set(provider.id, provider);
  }

  unregister(providerId: string): void {
    this.providers.delete(providerId);
  }

  getProviders(): SearchContentProvider[] {
    return Array.from(this.providers.values());
  }

  getActiveProviders(context: SearchProviderContext): SearchContentProvider[] {
    return this.getProviders().filter((provider) => {
      if (provider.isActive) {
        return provider.isActive(context);
      }
      return true; // Default to active if no isActive method
    });
  }

  getResults(context: SearchProviderContext): SearchResultItem[] {
    const activeProviders = this.getActiveProviders(context);

    // Get results from all active providers
    const allResults: SearchResultItem[] = [];

    activeProviders.forEach((provider) => {
      try {
        const results = provider.getResults(context);
        allResults.push(...results);
      } catch (error) {
        console.error(
          `Error getting results from provider ${provider.id}:`,
          error,
        );
      }
    });

    // Sort by priority (higher priority first), then by title
    return allResults.sort((a, b) => {
      if (a.priority !== b.priority) {
        return b.priority - a.priority; // Higher priority first
      }
      return a.title.localeCompare(b.title);
    });
  }
}

// Create and export the default registry instance
export const searchProviderRegistry = new DefaultSearchProviderRegistry();

// Export the registry class for testing or custom implementations
export { DefaultSearchProviderRegistry };
